import Housework from "../../view/Panel/housework/index.vue"
import Detail from "../../view/Panel/housework/detail.vue"
import Statistic from "../../view/Panel/houseworkStatistic/index.vue"

export default [
    {
        path: '/housework',
        component: Housework,
        name: 'Housework',
    },
    {
        path: '/houseworkDetail',
        component: Detail,
        name: 'HouseworkDetail',
        meta: { activeMenu: '/housework' }
    },
    {
        path: '/statistics',
        component: Statistic,
        name: 'HouseworkStatistics',
        meta: { activeMenu: '/housework' }
    },
]


// WEBPACK FOOTER //
// ./src/router/model/housework.js